import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=55851f89&scoped=true"
import script from "./Visit.vue?vue&type=script&lang=js"
export * from "./Visit.vue?vue&type=script&lang=js"
import style0 from "./Visit.vue?vue&type=style&index=0&id=55851f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55851f89",
  null
  
)

export default component.exports